<template>
    <div class="xiangmu">
		<div class="leaderBox" v-if="showOrhide">
			<div class="newtext">新手指引</div>
		  <img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
		  <img src="../../../assets/images/pop/bj/bj.jpg" class="steps step1" v-if="status==1">
		  <div class="stepbtn" @click="nextStep(status)">
		    {{status==1?"我知道了":"我知道了"}}
		  </div>
		  <div class="bottomTip">
		    <el-checkbox v-model="checked">下次不再提示</el-checkbox>
		  </div>
		</div>
<!--    <div class="h-crumbOut">-->
<!--      <div class="h-crumbs">-->
<!--        <el-breadcrumb separator="|">-->
<!--          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
<!--          <el-breadcrumb-item>-->
<!--            <a href="/xiangmu/pm">项目列表</a>-->
<!--          </el-breadcrumb-item>-->
<!--        </el-breadcrumb>-->
<!--      </div>-->
<!--    </div>-->
      <Breadtabsheader/>
    <div class="h-piece h-mrt30" >
        <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
			<div class="h-formBox w-formBox">
				<div class="tow-formBox">
					<el-form-item label="项目名称">
						<el-input v-model="q.projectNameLike" placeholder="请输入项目名称" clearable></el-input>
					</el-form-item>
					<el-form-item label="项目编码">
						<el-input v-model="q.idLike" placeholder="请输入项目编码" clearable></el-input>
					</el-form-item>
				</div>
				<el-from-item>
					<el-button class="h-btn h-formBtn" @click="query">检索</el-button>
					<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
				</el-from-item>
			</div>	
        </el-form>
    </div>
    <div class="h-table h-mrt30">
      <el-table
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        :data="tableData"
        stripe
		:border="true"
		max-height="510"
        style="width: 100%">
        <el-table-column type="index" label="#" width="40"></el-table-column>
        <el-table-column prop="projectName" label="项目名称" :show-overflow-tooltip="true">
			<template scope="scope">
				<div style="text-align: left;">
					{{scope.row.projectName}}
				</div>
			</template>
		</el-table-column>
        <el-table-column prop="id" label="项目编码" width="300" :show-overflow-tooltip="true"></el-table-column>
<!--        <el-table-column prop="productName" label="产品名称" width="240" :show-overflow-tooltip="true"></el-table-column>-->
    <el-table-column prop="cdate" label="创建时间"  width="300" :show-overflow-tooltip="true">
		</el-table-column>
    <el-table-column label="操作" width="120" fixed="right">
      <template slot-scope="scope">
		  <div class="w-caozuo" style="text-align: left;">
			  <router-link :to="{path:'/xiangmu/Pdetails', query: {id: scope.row.id,protype:scope.row.type,fromType:'gys'}}">
			    <el-button type="text" size="small" class="h-tableLink h-btn" style="">查看</el-button>
			  	<!-- <span class="l-operationlist br-operation-look" title="查看"></span> -->
			  </router-link>
			  <!--?taskid=20200116xQWiFBzv&ywid=2020011649596506&instid=20200116KQPPAk6n&taskstatus=0-->
			  <router-link v-auth="'caigoubaojia'" v-if="scope.row.type==5" :to="{path:'/xiangmu/commitsh', query: {ywid: scope.row.id,taskstatus: 0}}" >
			    <el-button type="text" size="small" class="h-tableLink h-btn" >报价</el-button>
			  	<!-- <span class="l-operationlist br-operation-bj" title="报价"></span> -->
			  </router-link>
		  </div>
        <!-- <div class="l-operationBox"> -->
			
			<!--<el-button  v-if="scope.row.type==5||scope.row.type==1"-->
			        <!--size="small" class="h-tableLink h-btn"-->
			        <!--@click="genzongLiuch(scope.row)">-->
			    <!--跟踪审批-->
			<!--</el-button>-->
		<!-- </div> -->
      </template>
    </el-table-column>
      </el-table>
      <div class="h-tableB h-mrt30">
        <!-- <div class="h-tableBL">
          <el-button
            class="h-btn h-formBtn h-bgblueQ"
            icon="h-el-icon h-el-icon-import"
            style="margin-left:-20px;"
            @click="exportExcel"
          >批量导出</el-button>
        </div> -->
        <div class="h-pagination2">
          <pagination :page="q" @query="query" />
        </div>
      </div>
    </div>
  <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
  </div>
</template>
<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile'
export default {
  data() {
    return {
	  checked:true,
      showOrhide:false,
	  toShow:'pmgys',
      status:1,
      //表单
      all: "全部",
      q: {
        pageSize: 20,
        pageNo: 1,
        total: 0,
        projectNameLike:'',
        idLike: '',
      },
      //表格
      multipleSelection: [],
      showhistory:false,
      instid:null,
      tableData: [],

    };
  },
  created() {
		this.showzhezhao()
  },
  methods: {
	  showzhezhao(){
	  	ss.salesList.toshow(this.toShow).then(rd => {
	  		console.log(rd)
	  	    if(rd == false){
	  	        this.showOrhide = false;
	  	    }else{
	  	        this.showOrhide = true;
	  	    }
	  	})
	  },
	closeIt(){
	  this.showOrhide = false;
	  if(this.checked){
		  ss.salesList.toshow(this.toShow,this.checked).then(rd => {
		  	console.log(rd)
		  	this.showOrhide = false;
		  })
	  }else{
		  ss.salesList.toshow(this.toShow,this.checked).then(rd => {
		  	console.log(rd)
		  	this.showOrhide = false;
		  })
	  }
	},
	nextStep(i){
	    console.log(i)
	    if(this.status ==1){
	        if(this.checked){
				ss.salesList.toshow(this.toShow,this.checked).then(rd => {
					console.log(rd)
					this.showOrhide = false;
				})
	        }else{
				ss.salesList.toshow(this.toShow,this.checked).then(rd => {
					console.log(rd)
					this.showOrhide = false;
				})
			}
	    }
	},


    //表格
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 重置按钮
    resetData(){
      this.q.customerNameLike = ""
      this.q.projectNameLike = ""
      this.q.idLike = ""
    },
    query() {
      this.q.ids=null;
      ss.ProService.pagechi(this.q).then(rd => {
        console.log(rd, "项目列表");
        this.q.total = rd.total;
        this.tableData = rd.records;
        console.log(rd,"================")
      });
    },
    genzongLiuch(r){
        console.log(r);
      this.instid = r.instid;
      this.showhistory = true;
    },
    handleFilter() {
      this.query();
  },
  //明细导出
    // exportExcel() {
    //   var idlist=[];
    //   this.multipleSelection.forEach(element => {
    //     idlist.push(element.id);
    //   });
    //   this.q.ids = idlist
    //   console.log("aaaaa",this.q.ids);
    //   // this.$export.exportData("/guanhuai/userCareExcel/downloadExcel",this.q)
    //     updownfile.down("/api/swyl/v1/xiangmu/proMain/getExcelgys",this.q,"post",'data');
    // },

  },
  mounted() {
	  this.query();

  }
};
</script>
<style scoped>
  .xiangmu > .h-piece,.h-mrt30 {
    margin: 20px;
    top: 0;
  }
</style>

<style scoped lang="scss">
    .bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
		z-index: 999999;
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
    .leaderBox{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;
		.leaderbg{
			width: 100%;
			height: 100%;

		}
		.steps{
			position: absolute;
			z-index: 1;

		}
		.step1{
			top: 0;
			left: 0;

		}
		.stepbtn{
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0,0,0,0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.75rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}
		.closeIt{
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
			z-index: 2;
		}
	}
</style>

